import React, { useContext, useEffect, useState } from "react";
import organisms from "../../../../components/organisms";
import Wrapper from "../../../../components/common/Wrapper/Wrapper";
import service from "../../../../api/services";
import { HeaderHeading } from "../../../../Context";
import constant from "../../../../constants/constant";
import molecules from "../../../../components/molecules";

const {RoleLayout} = molecules
const { Role } = organisms;
const Index = () => {
    const [rolesList, setRolesList] = useState();
    const [subAdminRole, setSubAdminRole] = useState<{
        label: string;
        value: number;
    }>(constant.ROLE_FOR[0]);
    const { setHeader, setSidebar }: any = useContext(HeaderHeading);
    const getRolesList = async () => {
        try {
            let response = await service.roles.list({
                role_for: subAdminRole?.value,
            });
            setRolesList(response.data);
        } catch (error) {
            console.error(error);
        }
    };
    const tabs = [
        {
            id: constant.ROLE_FOR[0].id,
            label: "Admin Role",
            target: "pane-one",
            Content: <Role rolesList={rolesList} />,
        },
        {
            id: constant.ROLE_FOR[1].id,
            label: "Store Role",
            target: "pane-two",
            Content: <Role rolesList={rolesList} />,
        },
    ];

    const onChangeTab = (value: string) => {
        const requiredTab = constant.ROLE_FOR.find((item) => item?.id === value);
        requiredTab && setSubAdminRole(requiredTab);
    };

    useEffect(() => {
        setHeader("Setting - Roles");
        setSidebar(false);
    }, []);

    useEffect(() => {
        getRolesList();
    }, [subAdminRole]);

    return (
        <Wrapper>
            <RoleLayout onClear={(value: string) => onChangeTab(value)} tabs={tabs} />
        </Wrapper>
    );
};

export default Index;
